export default "assets/images/mosaic-6b8a752c.jpg";